"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zm-1 14H2V2h12v12z"];
//# sourceMappingURL=square.js.map